import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

export default function BrandLogo({ size = 28, showText = true, text = 'EVM Bundler Manager', onClick }) {
  const [imgOk, setImgOk] = useState(true);
  const src = '/logo.png';
  const resolvedSize = typeof size === 'number' ? `${size}px` : size;

  return (
    <Box
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(e) => {
        if (!onClick) return;
        if (e.key === 'Enter' || e.key === ' ') onClick();
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        minWidth: 0,
        cursor: onClick ? 'pointer' : 'default',
        userSelect: 'none',
        outline: 'none',
      }}
    >
      {imgOk ? (
        <Box
          component="img"
          src={src}
          alt="Logo"
          onError={() => setImgOk(false)}
          sx={{
            height: resolvedSize,
            width: 'auto',
            maxWidth: '100%',
            objectFit: 'contain',
            filter: 'drop-shadow(0 6px 18px rgba(168, 85, 247, 0.22))',
          }}
        />
      ) : (
        <Box
          sx={{
            width: resolvedSize,
            height: resolvedSize,
            borderRadius: 1.25,
            backgroundImage:
              'linear-gradient(135deg, rgba(168, 85, 247, 0.95) 0%, rgba(99, 102, 241, 0.9) 50%, rgba(34, 211, 238, 0.85) 100%)',
            boxShadow: '0 10px 28px rgba(168, 85, 247, 0.20)',
          }}
        />
      )}

      {showText ? (
        <Typography
          variant="subtitle1"
          component="div"
          noWrap
          sx={{
            fontWeight: 800,
            letterSpacing: 0.4,
            backgroundImage:
              'linear-gradient(90deg, rgba(168, 85, 247, 1) 0%, rgba(99, 102, 241, 1) 45%, rgba(34, 211, 238, 1) 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          {text}
        </Typography>
      ) : null}
    </Box>
  );
}

